import React, { memo, useCallback, useMemo } from 'react';
import { MdArrowBack } from 'react-icons/md';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { ButtonPrimary, LinkButton } from '../../../../../../../components';
import styles from './RegrasDePrecoFooter.module.scss';

type RegrasDePrecoFooterProps = RouteComponentProps<{ id?: string }> & {
  isDisabledSubmit?: boolean;
};

const RegrasDePrecoFooter = memo(({ isDisabledSubmit, history, match }: RegrasDePrecoFooterProps) => {
  const isEditPage = useMemo(() => !!match.params?.id, []);

  const handleNavBack = useCallback(() => {
    history.goBack();
  }, [history]);
  return (
    <div className={styles.wrapper}>
      <LinkButton className={styles['link-button']} onClick={handleNavBack}>
        <MdArrowBack size={16} /> Voltar para regras
      </LinkButton>
      <ButtonPrimary type="submit" disabled={isDisabledSubmit} id={isEditPage ? 'edit-rule-btn' : 'save-rule-btn'}>
        {isEditPage ? 'editar regra' : 'salvar regra'}
      </ButtonPrimary>
    </div>
  );
});

RegrasDePrecoFooter.displayName = 'RegrasDePrecoFooter';

export default withRouter(RegrasDePrecoFooter);
